import { useEffect, useState } from 'react';
import DashboardNavBar from './DashboardNavBar';
import DashboardNavBar2 from './DashboardNavBar2';
import bankOptions from './bankOptions';

const BankView = ({onPostBank}) => {
	
	var output;
	const [fullname, setFullName] = useState(localStorage.getItem('fullname'));
	const [verify, setVerify] = useState(localStorage.getItem('bankverify'));
	const [user, setUser] = useState(localStorage.getItem('useremail'));
	const [bankacct, setBankAcct] = useState(localStorage.getItem('bankacct'));
	const [bankabbr, setBankAbbr] = useState(localStorage.getItem('bankabbr'));
	const [otherbank, setOtherBank] = useState(localStorage.getItem('otherbank'));
	const [bankmemo, setBankMemo] = useState(localStorage.getItem('bankmemo'));
	const [banktitle, setBankTitle] = useState(localStorage.getItem('banktitle'));
	
		
	useEffect(() => {
		document.getElementById('banktab').style.color = '#23527C';
		document.getElementById('banktab').style.fontWeight = '700';
		document.getElementById('banktab').style.borderBottom = '1px solid #23527C';
		if(banktitle && banktitle !== ''){
			document.getElementById('banktitle').innerHTML = banktitle;
			document.getElementById('banktitle').className = 'incsizespan_info center';
		}else{
			document.getElementById('banktitle').innerHTML = '';
			document.getElementById('banktitle').className = 'incsizespan center';
		}
		
		if(bankmemo && bankmemo !== ''){
			document.getElementById('bankcodewrap').className = 'container__control--input';
			document.getElementById('bankfeedback').innerHTML = bankmemo;
			document.getElementById('bankfeedback').className = 'incsizespan_info center';
		}
		
		setBankAcct(bankacct);
		setBankAbbr(bankabbr);
		setOtherBank(otherbank);		
		
		if(otherbank !== '' && otherbank !== null && otherbank !== 'undefined'){			
			var i, otherbankarr, otherbankabbr, otherbankacct, otherbankabbrarr, otherbankacctarr, otherbanklist;
			otherbankarr = otherbank.split("-");
			otherbankacct = otherbankarr[0];
			otherbankabbr = otherbankarr[1];
			otherbankacctarr = otherbankacct.split("|");
			otherbankabbrarr = otherbankabbr.split("|");
			otherbanklist = '<ol class="messages__list">';
			if(bankabbr && bankacct !== 'undefined'){
				otherbanklist += '<li class="messages__item"><img class="messages__pic" src="https://endopay.com/images/bd.png" alt="Bank"/><article class="messages__content"><div class="messages__heading"><h3 class="messages__name">'+bankacct+'</h3><h4 class="messages__time">MAIN</h4></div><p class="messages__text">'+bankabbr+'</p></article></li>';
			}
			for(i=0; i<otherbankacctarr.length; i++){
				if(otherbankacctarr[i] && otherbankacctarr[i] !== 'undefined'){
					otherbanklist += '<li class="messages__item"><img class="messages__pic" src="https://endopay.com/images/bd.png" alt="Bank"/><article class="messages__content"><div class="messages__heading"><h3 class="messages__name">'+otherbankacctarr[i]+'</h3><h4 class="messages__time messages__time2"><span id="apply_'+i+'" onclick="makeDefault(\''+otherbankacctarr[i]+'\', \'apply_'+i+'\')">APPLY</span></h4></div><p class="messages__text">'+otherbankabbrarr[i]+'</p></article></li>';
				}
			}
			otherbanklist += '</ol>';
			if(document.getElementById('messagelist')){
				document.getElementById('messagelist').innerHTML = otherbanklist;
			}		
		}else if(document.getElementById('messagelist')){
			document.getElementById('messagelist').innerHTML = 'No data to list';
		}
		
		
	},[banktitle, bankmemo, bankabbr, bankacct, otherbank]);
	
	
	const onSubmitBank = (e) => {
		
		var name, account, bank, email, rtype, msg, bankcode;
		name = document.getElementById('bankaccountname').value;
		account = document.getElementById('bankaccountno').value;
		bank = document.getElementById('bankname').value;
		email = document.getElementById('loggedemail').value;
		
		setUser(user);
		setVerify(verify);
		setFullName(fullname);
		setBankMemo(bankmemo);
		setBankTitle(banktitle);
		
		if(!name){
			msg = 'Enter a valid account name';
			document.getElementById('bankfeedback').innerHTML = msg;
			document.getElementById('bankfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!account)
		{
			msg = 'Enter a valid account number';
			document.getElementById('bankfeedback').innerHTML = msg;
			document.getElementById('bankfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!bank)
		{
			msg = 'Please select a Bank';
			document.getElementById('bankfeedback').innerHTML = msg;
			document.getElementById('bankfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!document.getElementById('bankcodewrap').classList.contains('hide')){
			bankcode = document.getElementById('bankcode').value;
			
			if(!bankcode){
				if(bankmemo){
					msg = bankmemo;
				}else{
					msg = 'Enter the amount sent your bank';
				}
				document.getElementById('bankfeedback').innerHTML = msg;
				document.getElementById('bankfeedback').className = 'incsizespan_info center';
				return false;
			}
		}		
		
		
		if(document.getElementById('bank2')){
			rtype = 'addbank2';
		}else{
			rtype = 'addbank';
		}

		if(bankcode){
			output = {
				'rtype': rtype,
				'name': name,
				'account': account,
				'bank': bank,
				'email': email,			
				'depositcode': bankcode,			
				'key': localStorage.getItem('_key')
			};
		}else{
			output = {
				'rtype': rtype,
				'name': name,
				'account': account,
				'bank': bank,
				'email': email,			
				'key': localStorage.getItem('_key')
			};
		}
		
		onPostBank(output);
	}
	
	
	return [
	(	
		<div className="container__canvas" style={rectStyleWrap} key="1"><div name="fadeStart" key="dv0" id="dv0"> <div className="tooltip"> <ul className="notification-list"> <li className="notification-item"> <div className="img-left"> <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"> <g className="layer"> <g fill="#000000" id="svg_1" transform="translate(0, 160) scale(0.1, -0.1)"> <path d="m112.7258,1553.26096c-31.91754,-21.26496 -41.49282,-29.60415 -56.99562,-49.20126c-8.66333,-10.84096 -15.50281,-20.84799 -15.50281,-22.93279c0,-1.66784 -3.19175,-8.33919 -7.29544,-15.42752c-17.78263,-31.27199 -15.04685,-99.65339 5.47157,-139.26457c15.50281,-30.43806 60.64335,-70.88316 95.29667,-85.89371c24.16614,-10.424 76.60211,-20.43102 82.07369,-15.42752c0.91194,1.25089 -5.92754,6.67136 -15.95878,12.92575c-21.88632,13.34271 -36.4772,31.27199 -56.53966,69.21533c-20.97439,40.4451 -27.3579,75.88668 -24.16614,137.17977c2.27982,44.19773 8.66333,74.6358 21.43036,105.49083c7.29544,16.67838 -5.01561,18.34623 -27.81386,3.33568l0,0l0,0.00001l0.00001,-0.00001l0.00001,0z" id="svg_3"/> <path d="m239.48405,1540.33521c-11.39912,-10.424 -27.3579,-30.43806 -35.56527,-44.6147c-12.76702,-22.09887 -15.50281,-30.85502 -16.87071,-62.127c-1.82386,-30.0211 -0.91194,-37.10943 5.01561,-39.19422c10.48719,-3.33568 77.97001,33.77374 104.87194,58.37437c13.22299,11.67488 27.81386,28.35326 32.37351,36.69246l9.11929,15.42752l-24.62211,20.84799c-13.67895,11.67488 -28.26983,22.51582 -32.82948,23.76671c-4.55965,1.25089 -8.20737,4.1696 -8.20737,6.25439c0,8.75616 -14.13492,2.50175 -33.28544,-15.42752l0,0l0,-0.00001l0.00002,-0.00001l0.00001,0.00001z" id="svg_4"/> <path d="m366.69829,1456.52628c-9.57526,-26.26846 -87.08931,-81.30716 -135.42159,-95.48379c-12.31105,-3.75264 -23.71018,-8.33919 -25.07807,-10.424c-1.3679,-2.0848 5.47157,-17.09535 15.04685,-33.77374c17.78263,-31.27199 60.64335,-74.21884 73.86633,-74.21884c4.10368,0 17.78263,8.33919 30.09369,18.34623c52.89193,42.11294 75.23421,118.41658 52.89193,181.79448c-6.83947,19.59711 -8.20737,21.68191 -11.39912,13.75967l0,0l-0.00001,0l-0.00001,-0.00001z" id="svg_5"/> </g> </g> </svg> </div> <div className="user-content"> <p className="user-info"><span className="name">{fullname}</span></p> <p className="time">Status: {verify === '0' ? 'Unverified' : 'Verified'}</p> </div></li> </ul> </div></div><div className="Context"> {verify === '1' ? (<DashboardNavBar />) : (<DashboardNavBar2 />)} </div> </div>	
	),
	(<div className="[ stack ] [ container__controls ]" key="2">
		<input type="hidden" id="loggedemail" value={user || ''} />	
		<div className="container__control--switch" key="dv22">
			<button className="switch-btn">
				<span className="switch-btnn__marker" id="switch-btnn__marker"></span>
				<span className="center-xy switch-btn__label" ></span>
				<span className="center-xy switch-btn__label" id="4r1" >MANAGE BANK</span>
				<span className="center-xy switch-btn__label" ></span>
			</button>
			
		</div>
	
		<div className="stack disshow" id="bankdisplay" key="dv23">
			<div style={center}>
				<h4 style={lineTwo} >ADD BANK</h4>
			</div>
			
			<div className="incsizespan_info center" id="banktitle">
				SMALL AMOUNT WILL BE SENT TO YOUR BANK ACCOUNT
			</div>
			
			{verify === '1' ? (<div className="incsizespansms center">Account Name: {fullname}<input type="hidden" name="bankaccountname" id="bankaccountname" value={fullname} /><input type="hidden" name="bank2" id="bank2" /></div>) : (<div className="container__control--input">
				<input className="text-input" type="text" name="bankaccountname" id="bankaccountname" placeholder="Bank Account Name" />
			</div>)}
			
			<div className="container__control--input">
				<input className="text-input" type="text" name="bankaccountno" id="bankaccountno" placeholder="Bank Account Number" maxLength="10" />
			</div>
			
			<div className="container__control--select">						
				<select
					className="select-input"
					name="bankname"
					id="bankname"
				>
					{bankOptions.map((group) => (
						<optgroup key={group?.label} label={group?.label}>
							{group?.options.map((option) => (
								<option key={option.value} value={option.value}>
									{option?.label}
								</option>
							))}
						</optgroup>
					))}
				</select>
			</div>
			
			<div id="bankcodewrap" className="container__control--input hide">
				<input className="text-input" type="text" name="bankcode" id="bankcode" placeholder="Deposited Amount" maxLength="10" />
			</div>
			
			<div className="incsizespan center" id="bankfeedback">
				
			</div>				
			<div className="container__buttons">
				<button className="clipboard" id="bankproceed" onClick={onSubmitBank}>PROCEED</button>
			</div>
			
			<main className="messageapp">
			  <header className="messageheader">
				<h3 className="messageheader__title">Saved Accounts</h3>
			  </header>
			  <section className="messages" id="messagelist">
				
			  </section>
			</main>
			
		</div>			
	</div>)

	]
	
}

const lineTwo = {
   fontSize: '15px',
   color: '#23527c',
   lineHeight: '45px',
   fontWeight: '700'
}
const rectStyleWrap = {
   minWidth: '250px',
   gridColumn: 1
}
const center = {
   textAlign: 'center'   
}
export default BankView;